import React, { useState, useEffect } from "react";
import _ from "lodash";
import { getStartTimeOptions } from "../../utils";
import { getRoomColor, resolveColorKey } from "../../utils/locationColor";
import { getTimeslotIndices } from "./timeslotIndices";
import "./index.css";

const timeslots = getStartTimeOptions();

const AppointmentTimeslot = ({ selectStartTime, duration, startTime, bookedTimeslots, availableTimeslots }) => {
  const [selectedSlotIndices, setSelectedSlotIndices] = useState([]);
  const [availableSlotIndices, setAvailableSlotIndices] = useState([]);
  const [bookedSlotIndices, setBookedSlotIndices] = useState([]);
  useEffect(() => {
    if (!startTime) {
      return;
    }
    setSelectedSlotIndices(getTimeslotIndices(timeslots, { startTime, duration }));
  }, [startTime, duration]);

  useEffect(() => {
    if (_.isEmpty(availableTimeslots)) {
      setAvailableSlotIndices([]);
      return;
    }
    let indices = [];
    availableTimeslots.forEach((slot) => {
      if (!slot.start) {
        return;
      }
      indices = indices.concat(
        getTimeslotIndices(
          timeslots,
          {
            startTime: slot.start,
            endTime: slot.end,
          },
          (idx) => ({
            idx,
            colorKey: resolveColorKey(slot),
          })
        )
      );
    });
    setAvailableSlotIndices(indices);
  }, [availableTimeslots]);

  useEffect(() => {
    if (_.isEmpty(bookedTimeslots)) {
      setBookedSlotIndices([]);
      return;
    }
    let indices = [];
    bookedTimeslots.forEach((slot) => {
      if (!slot.aptStart) {
        return;
      }
      indices = indices.concat(
        getTimeslotIndices(timeslots, {
          startTime: slot.aptStart,
          endTime: slot.aptEnd,
        })
      );
    });
    setBookedSlotIndices(indices);
  }, [bookedTimeslots]);

  const getBackgroundColorClass = (idx) => {
    let className = "has-background-white";
    if (availableSlotIndices.map(({ idx }) => idx).includes(idx)) {
      const colorKey = availableSlotIndices.find(({ idx: index }) => index === idx)?.colorKey;
      className = getRoomColor(colorKey)?.className ?? "no-room-available-background";
    }
    if (selectedSlotIndices.includes(idx)) {
      className = "selected has-background-info";
    }
    if (bookedSlotIndices.includes(idx)) {
      className = "selected has-background-primary";
    }
    return className;
  };

  return timeslots.map((ts, idx) => (
    <div
      className={`${getBackgroundColorClass(idx, ts)} has-text-centered py-1`}
      key={idx}
      onClick={() => selectStartTime(ts.value)}
    >
      {ts.label}
    </div>
  ));
};

export default AppointmentTimeslot;
